import { useTLang } from 'intl/intl';

export function useLoadingCatalogLang() {
  return {
    title: useTLang({ id: 'menuPage.board.loading.title' }),
    description: useTLang({ id: 'menuPage.board.loading.description' }),
  };
}
